export const YouTubeVideoContainer = () => {
  return (
    <div className="gosse-video-container">
      <iframe
        width="100%"
        height="720"
        src="https://www.youtube.com/embed/rEHdCtw7GdM?si=axDhLhEL603rr-9v"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  );
};
